import { render, staticRenderFns } from "./transfer-card-list-dialog.vue?vue&type=template&id=5b40192e&scoped=true"
import script from "./transfer-card-list-dialog.vue?vue&type=script&lang=js"
export * from "./transfer-card-list-dialog.vue?vue&type=script&lang=js"
import style0 from "./transfer-card-list-dialog.vue?vue&type=style&index=0&id=5b40192e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b40192e",
  null
  
)

export default component.exports